import ServicesApi from '../services/api/service.js';
import servicesMixin from './services.js';

import store from '@/store/index.js';

/**
 * Imports service with guard check on domain name.
 */
export default {
    mixins: [servicesMixin],
    /**
     * Check if we can enter the route.
     *
     * @param {object} to
     * @param {object} from
     * @param {function} next
     */
    beforeRouteEnter(to, from, next) {
        if (!to.params.domain) {
            next();

            return;
        }

        if (store.getters['services/items'].some(service => service.domain === to.params.domain)) {
            next();

            return;
        }

        ServicesApi.get().then(services => {
            if (services.data.data.some(service => service.domain === to.params.domain)) {
                next();

                return;
            }

            next({ name: 'error.403' });
        });
    }
};
